var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "card c-pointer",
      on: {
        click: function($event) {
          return _vm.$emit("select")
        }
      }
    },
    [
      _c("div", { staticClass: "card-body p-2" }, [
        _c("div", { staticClass: "w-100 d-flex flex-row" }, [
          _c(
            "div",
            { staticClass: "flex-grow-0", staticStyle: { width: "50%" } },
            [
              _c("div", [_vm._v(_vm._s(_vm.board && _vm.board.name))]),
              _vm._v(" "),
              _c("div", [
                _c("i", { staticClass: "fa fa-chevron-right pl-2" }),
                _vm._v(" " + _vm._s(_vm.flow && _vm.flow.name))
              ]),
              _vm._v(" "),
              _c("div", [
                _c("i", { staticClass: "fa fa-chevron-right pl-4" }),
                _vm._v(" " + _vm._s(_vm.card && _vm.card.name))
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow-1" }, [
            _c("div", [_vm._v(_vm._s(_vm.startTime))]),
            _vm._v(" "),
            _c("div", { staticStyle: { "font-size": "2em" } }, [
              _vm._v(_vm._s(_vm.totalDurationString))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("CenterOnParent", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.$emit("start")
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-play" })]
                )
              ])
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }